import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";

type VerticalTableProps = {
  data: { label: string; value: string | number }[];
  title: string;
};

export default function VerticalTable({ data, title }: VerticalTableProps) {
  const rowStyle = {
    padding: "10px",
  };

  return (
    <Paper>
      <Table>
        <TableBody>
          <TableRow key={title} sx={rowStyle}>
            <TableCell>
              <Typography fontSize={20} color={"primary"}>
                {title}
              </Typography>
            </TableCell>
            <TableCell />
          </TableRow>
          {data.map((d, _) => {
            return (
              <TableRow key={d.label} sx={rowStyle}>
                <TableCell variant="head">{d.label}</TableCell>
                <TableCell>{d.value}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Paper>
  );
}
